import { render, staticRenderFns } from "./GlyphSetRecordsTab.vue?vue&type=template&id=133e8d46&"
import script from "./GlyphSetRecordsTab.vue?vue&type=script&lang=js&"
export * from "./GlyphSetRecordsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports